import { fetchWithAuth } from "../utils/authFetch";

/**
 * Pipeline status, one row per candidate.
 *
 * Status is per ASSIGNMENT: `jobs` holds one entry per job the candidate is on,
 * and there is no candidate-level status. Each write touches a single field, so
 * concurrent edits from two tabs don't clobber each other.
 */

/** GET every candidate's state → { [candidateId]: { jobs } }. */
export async function getCandidateState() {
  const res = await fetchWithAuth("/api/me/candidate-state");
  if (!res.ok) throw new Error(`candidate-state GET ${res.status}`);
  const data = await res.json();
  return data?.states || {};
}

/**
 * Set one candidate's status on one job. `jobId` is required — a stage only
 * means something against a role.
 *
 * The server writes just that one field, so concurrent edits to different jobs
 * on the same candidate both survive.
 * @returns {{ ok: true, state: { jobs: object } }}
 */
export async function patchCandidateStatus(candidateId, { jobId, status }) {
  if (!jobId) throw new Error("patchCandidateStatus needs a jobId");
  const res = await fetchWithAuth(
    `/api/me/candidate-state/${encodeURIComponent(candidateId)}`,
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status, jobId }),
    },
  );
  if (!res.ok) throw new Error(`candidate-state PATCH ${res.status}`);
  return res.json();
}
